import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import s from './DeviationMosaic.scss';
/** Sidebar block layout id 3 */ const DeviationMosaic = ({ block, deviation: parentDeviation })=>{
    var _block_deviations;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(DeviationSidebarMosaic, {
        streamId: `sidebar-mosaic-${block.contentType}`,
        deviations: (_block_deviations = block.deviations) !== null && _block_deviations !== void 0 ? _block_deviations : [],
        parentDeviation: parentDeviation
    })));
};
DeviationMosaic.displayName = 'DeviationMosaic';
export default DeviationMosaic;
